<template>
    <div>
        <label>{{ label }}</label> {{ date }} {{ $trad.common.by }} <strong>{{ author }}</strong>
    </div>
</template>

<script>
export default {
    props: ["label", "author", "date"]
};
</script>
<style lang="scss" scoped>
div {
    color: #a8a8a8;
    font-size: 12px;

    display: inline-block;
    vertical-align: baseline;
    margin: 0px 2px;
    border: 1px #a8a8a8 solid;
    text-transform: none;
    padding-right: 5px;

    > * {
        font-size: 12px;
    }

    label {
        margin-right: 5px;
        display: inline-block;
        background-color: #a8a8a8;
        color: white;
        font-weight: bold;
        width: 23px;
        height: 23px;
        line-height: 23px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// author-badge.vue?63aa2640